import { render } from "./TitleBlock.vue?vue&type=template&id=e81bc3f8&scoped=true"
import script from "./TitleBlock.vue?vue&type=script&lang=js"
export * from "./TitleBlock.vue?vue&type=script&lang=js"

import "./TitleBlock.vue?vue&type=style&index=0&id=e81bc3f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e81bc3f8"]])

export default __exports__